// extracted by mini-css-extract-plugin
export default {"p_tye":"_1433ddddf6","slcted":"_7dbb269f9b","slc_color":"_76a65e50c4","item_p":"_930686ba92","r0":"_9c7398983d"};